import { put, takeLatest } from "redux-saga/effects";
import {
    startAtlasBackupSuccess,
    startAtlasBackupFailed,
    updateBackupJobStatus,
} from "../reducers/backupSlice";
import { axiosInstance } from "../../config/axios";
import { apiEndpoints } from "../../utils/api-endpoints";
import { createErrorAction } from '../reducers/errorSlice';
import { getErrorMessage } from '../../utils/helper.utils';
import { delay } from 'redux-saga/effects';

function* startAtlasBackup(action: any): any {
    try {
        const response = yield axiosInstance.post(apiEndpoints.backup.start, { 
            atlasUri: action.payload 
        });
        
        yield put(startAtlasBackupSuccess(response.data.data));

        const jobId = response.data.data.jobId;
        
        // Poll for job status updates
        while (true) {
            const jobResponse = yield axiosInstance.get(apiEndpoints.backup.status(jobId));
            yield put(updateBackupJobStatus(jobResponse.data.data));
            
            if (['completed', 'failed'].includes(jobResponse.data.data.status)) {
                break;
            }
            yield delay(2000); // Poll every 2 seconds
        }
    } catch (error) {
        yield put(startAtlasBackupFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'backup/startAtlasBackup'));
    }
}

export function* watchBackupSaga() {
    yield takeLatest('backup/startAtlasBackup', startAtlasBackup);
}

